import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import infiniteScroll from 'vue-infinite-scroll'
Vue.config.productionTip = false

Vue.use(infiniteScroll)
import BaiduMap from 'vue-baidu-map'
Vue.prototype.$EventBus = new Vue()

Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'r4uGwGDohrhw49mohZoqwc8wA2wU7VFV'
})
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// const colorListLength = 20
// function getRandColor () {
//  var tem = Math.round(Math.random() * colorListLength)
//  return colorList[tem]
// }
// export default
// {
//  colorListLength,
//  getRandColor
// }